import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/hoavang.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "user header",
  src: _imports_0
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong"),
  /*#__PURE__*/_createTextVNode(" TRUNG TÂM Y TẾ HOÀ VANG.")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Địa chỉ: "),
  /*#__PURE__*/_createTextVNode(" Thạch Nham Đông, Hòa Nhơn, Hòa Vang, TP. Đà Nẵng")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Số điện thoại: "),
  /*#__PURE__*/_createTextVNode(" 02363.789.123")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    title: _withCtx(() => []),
    content: _withCtx(() => [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4
    ]),
    footer: _withCtx(() => []),
    _: 1
  }))
}